export default __webpack_public_path__ + "static/media/BOD.9213a78f.png";